import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ServicesSection from "../components/ServicesSection";

const heroSlides = [
  {
    img: "/img/s7.jpg",
    titleAr: "دراسات الجدوى الاحترافية",
    titleEn: "Professional Feasibility Studies",
    subAr: "تحليل دقيق • قرارات ذكية • نجاح مستدام",
    subEn: "Precise Analysis • Smart Decisions • Sustainable Success",
  },
  {
    img: "/img/s2.jpg",
    titleAr: "ابدأ مشروعك بثقة",
    titleEn: "Start Your Project with Confidence",
    subAr: "نقدم لك رؤية واضحة قبل الاستثمار",
    subEn: "We give you clarity before investment",
  },
  {
    img: "/img/s3.jpg",
    titleAr: "حلول استشارية متكاملة",
    titleEn: "Integrated Consulting Solutions",
    subAr: "من الفكرة إلى التنفيذ بخطوات مدروسة",
    subEn: "From idea to execution with structured planning",
  },
];

export default function Feasibility({ language = "en" }) {
  const [slideIndex, setSlideIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % heroSlides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  // 🔒 check login
  const handleProtectedRoute = () => {
    const token = localStorage.getItem("auth_token");

    if (token) {
      navigate("/terms/feasibility");
    } else {
      navigate("/login", { state: { from: "/terms/feasibility" } });
    }
  };

  return (
    <div className="feasibility-page">

      {/* HERO */}
      <section className="feasibility-hero">

        {heroSlides.map((slide, i) => (
          <div
            key={i}
            className={`hero-slide ${i === slideIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.img})` }}
          />
        ))}

        <div className="overlay-gradient"></div>

        <motion.div
          key={slideIndex}
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h1>
            {language === "ar"
              ? heroSlides[slideIndex].titleAr
              : heroSlides[slideIndex].titleEn}
          </h1>

          <p className="hero-sub">
            {language === "ar"
              ? heroSlides[slideIndex].subAr
              : heroSlides[slideIndex].subEn}
          </p>

          <div className="hero-buttons">

            {/* 🔥 زر محمي */}
            <button className="btn primary" onClick={handleProtectedRoute}>
              {language === "ar" ? "ابدأ الآن" : "Get Started"}
            </button>

            <a href="#services" className="btn outline">
              {language === "ar" ? "استكشف المزيد" : "Learn More"}
            </a>
          </div>
        </motion.div>

      </section>
      <div className="trust-bar">
  <span>+500 {language === "ar" ? "عميل" : "Clients"}</span>
  <span>98% {language === "ar" ? "نسبة رضا" : "Satisfaction"}</span>
  <span>+120 {language === "ar" ? "مشروع ناجح" : "Projects"}</span>
</div>

      {/* WHY */}
      <section className="why-split">

        <div className="why-image">
          <img src="/img/s7.jpg" alt="Why Us" />
        </div>

        <div className="why-text">

          <h2>
            {language === "ar" ? "لماذا نحن؟" : "Why Choose Us?"}
          </h2>

        <p className="why-big-text">
  {language === "ar"
    ? "نحن لا نقدم مجرد دراسات تقليدية، بل نوظف الذكاء الصناعي لتحليل البيانات بدقة عالية، مما يمنحك رؤية واضحة، قرارات أسرع، وفرص نجاح أعلى في عالم تنافسي"
    : "We don’t deliver traditional studies — we leverage AI-powered analysis to provide you with clear vision, faster decisions, and higher success rates in a competitive market."}
</p>

        </div>

      </section>

      {/* SERVICES */}
      <div id="services">
        <ServicesSection language={language} />
      </div>

      {/* FLIP CARDS */}
      <section className="flip-section">

        
        <div className="flip-card">
          <div className="flip-inner">

            <div className="flip-front">
              <img src="/img/s4.jpg" alt="Feasibility" />
             <div className="front-title">
  {language === "ar"
    ? "الدراسة الفنية والتشغيلية"
    : "Technical & Operational Study"}
</div>
            </div>

            <div className="flip-back">
             <p>
  {language === "ar"
    ? "نحلّل المتطلبات الفنية والتشغيلية للمشروع، من المعدات والتقنيات والطاقة الإنتاجية إلى الكوادر وخطط التشغيل، لضمان كفاءة الأداء واستدامة العمليات."
    : "We assess the project's technical and operational requirements, including equipment, technology, production capacity, staffing, and operating plans, to ensure efficient performance and sustainable operations."}
</p>

              <button className="flip-btn" onClick={handleProtectedRoute}>
                {language === "ar" ? "ابدأ الآن" : "Start Now"}
              </button>
            </div>

          </div>
        </div>
       

        <div className="flip-card">
          <div className="flip-inner">

            <div className="flip-front">
              <img src="/img/s5.jpg" alt="Market Study" />
              <div className="front-title">
  {language === "ar"
    ? "دراسات السوق والتحليل التجاري"
    : "Market Studies & Business Analysis"}
</div>
            </div>

            <div className="flip-back">
             <p>
  {language === "ar"
    ? "تحليل شامل للسوق باستخدام الذكاء الصناعي لفهم الاتجاهات والمنافسين وتحديد أفضل الفرص الاستثمارية"
    : "Full market analysis powered by AI to understand trends, competitors, and identify the best investment opportunities."}
</p>

              <button className="flip-btn" onClick={handleProtectedRoute}>
                {language === "ar" ? "ابدأ الآن" : "Start Now"}
              </button>
            </div>

          </div>
        </div>

      </section>


<section className="immersive">

  <div className="immersive-bg"></div>

  <div className="immersive-content">

    <h2>
      {language === "ar"
        ? "ليس كل مشروع يستحق أن يبدأ"
        : "Not Every Idea Deserves to Be Built"}
    </h2>

    <p className="immersive-sub">
      {language === "ar"
        ? "النجاح لا يعتمد على الحماس… بل على القرار الصحيح المبني على البيانات"
        : "Success is not driven by excitement — it's driven by the right data-backed decision."}
    </p>

    <div className="immersive-lines">

      <p>
        {language === "ar"
          ? "نحن نحلل فكرتك بعمق"
          : "We analyze your idea deeply"}
      </p>

      <p>
        {language === "ar"
          ? "نكشف لك المخاطر قبل أن تواجهها"
          : "We uncover risks before you face them"}
      </p>

      <p>
        {language === "ar"
          ? "ونمنحك وضوح كامل قبل أن تستثمر"
          : "And give you full clarity before you invest"}
      </p>

    </div>

  </div>

</section>

     <section className="testimonials-pro">

  <div className="testi-bg"></div>

  <div className="testi-content">

    <h2>
      {language === "ar"
        ? "تجربة حقيقية… قرار مختلف"
        : "A Real Experience. A Different Decision."}
    </h2>

    <div className="testi-quote">

      <span className="quote-mark">“</span>

      <p>
        {language === "ar"
          ? "كنت على وشك استثمار مبلغ كبير في مشروع غير واضح. الدراسة غيّرت قراري بالكامل، وأنقذتني من خسارة كبيرة"
          : "I was about to invest a significant amount into an unclear project. The study completely changed my decision and saved me from a major loss."}
      </p>

     <div className="testi-author">

  <img
    src="/img/hamzeh.jpg"  // حط صورتك هنا
    alt="Ahmed"
    className="testi-avatar"
  />

  <div>
    <strong>Ahmed</strong>
    <span>
      {language === "ar" ? "رائد أعمال" : "Entrepreneur"}
    </span>
  </div>

</div>

    </div>

  </div>

</section>

      {/* CTA */}
      <div className="final-cta">
        <motion.div
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <button className="cta-btn big" onClick={handleProtectedRoute}>
            {language === "ar"
              ? "الانتقال إلى الشروط"
              : "Proceed to Terms"}
          </button>
        </motion.div>
      </div>

    </div>
  );
}
